import React from 'react';
import styled from "styled-components";

const Header=styled.div`
border-top-left-radius: 10px;
border-top-right-radius: 10px;
background-color:#0088FF;
display:grid;
grid-template-columns: 50% 50%;
`;

const Text=styled.p`
text-align:center;
font-weight:bold;
font-size:24px;
margin:10px 0;
color:white;

@media screen and (max-width:500px)
{
    font-size:14px;
}
`;

export default function CustomerHeaderGrid() 
{
    return <Header>
        <Text>Nombre</Text>
        <Text>Cantidad</Text>
    </Header>
}
